import React from 'react';

import styles from './ScrollIndicator.module.scss';

const ScrollIndicator = ({ className }) => {
  const [isHidden, setHidden] = React.useState(false);
  const onScroll = () => {
    setHidden(window.scrollY > 100);
  };
  React.useEffect(() => window.addEventListener('scroll', onScroll), []);

  React.useEffect(() => {
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  return (
    <div
      className={`${styles.indicator} ${className} ${isHidden &&
        styles.hidden} `}
    ></div>
  );
};

export default ScrollIndicator;
